// extracted by mini-css-extract-plugin
module.exports = {"sidebarProductSize":"ProductIframe_sidebarProductSize__1jWwP"};